import React from 'react';

import Icon from 'components/common/Icons/base/Icon/Icon';

import { CustomizedRoundIcon, CustomizedTooltip } from 'components/common';

export interface IActionMenuTooltipProps {
    value: string;
    status?: 'pending';
}

export const ActionMenuTooltip = ({ value, status = undefined }: IActionMenuTooltipProps) => {
    const props: { backGroundColor?: string; hoverColor?: string } = {};
    if (status === 'pending') {
        props.backGroundColor = '#fff2e0';
        props.hoverColor = 'none';
    }

    return (
        <CustomizedTooltip
            triggerElement={
                <CustomizedRoundIcon size={'30px'} {...props}>
                    <Icon name={'ANALYTICS'} size={'16px'} color={'var(--button-tertiary-fg)'} />
                </CustomizedRoundIcon>
            }
            tooltipContent={<div>{value}</div>}
        />
    );
};
